// Tabs/TabPanelContent.patents.tsx
import React from 'react';
import DynamicTabContentTable from './DynamicTabContentTable';
import DynamicTabContentCard from "./DynamicTabContentCard";

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentPatents: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            {/* No static components currently in Patents */}
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="patents"  />
        </div>
        <div className="col-3 col-sm-3">
            <DynamicTabContentCard dynamicCollections={dynamicCollections} tabName="patents" />
        </div>
    </div>
);

export default TabPanelContentPatents;
